import { render } from "./GoalsList.vue?vue&type=template&id=bf5c06b6&scoped=true"
import script from "./GoalsList.vue?vue&type=script&lang=js"
export * from "./GoalsList.vue?vue&type=script&lang=js"

import "./GoalsList.vue?vue&type=style&index=0&id=bf5c06b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf5c06b6"]])

export default __exports__